/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect} from 'react';

import {useMemoizePrevious} from './useMemoizePrevious';

export function useDeepCompareEffect(callback: React.EffectCallback, dependencies: React.DependencyList) {
  useEffect(callback, useMemoizePrevious<React.DependencyList>(dependencies, []));
}
